import consumer from "./consumer"

document.addEventListener("turbo:load", () => {
  const container = document.querySelector("#rep-assignment-logs")
  const exhibitorId = container?.dataset?.exhibitorId

  if (exhibitorId) {
    consumer.subscriptions.create(
      { channel: "RepAssignmentLogsChannel", exhibitor_id: exhibitorId },
      {
        connected() {
          console.log("Connected to RepAssignmentLogsChannel", exhibitorId)
        },
        disconnected() {
          console.log("Disconnected from RepAssignmentLogsChannel")
        },
        received(data) {
          if (data.refresh) {
            if ($.fn.DataTable.isDataTable("#assignment-logs-table")) {
              $("#assignment-logs-table").DataTable().ajax.reload(null, false)
            }
          }
        }
      }
    )
  }
})
